
import { Component, Renderer2 } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Subscription } from "rxjs";
import { AppRoutes } from "@utils/constants";  // import constants for routing
import { MenuService } from "@utils/menu-active";
import { ResponsivesidebarService } from "@utils/responsivesidebar";


/**
 * MainSidebar component.
 * Provides the main sidebar navigation, handles menu selection,
 * and manages responsive sidebar open/close state.
 */
@Component({
  selector: "app-main-sidebar",
  standalone: true,
  imports: [RouterModule],
  templateUrl: "./main-sidebar.html",
  styleUrl: "./main-sidebar.scss",
})
export class MainSidebar {
  // Track the selected menu item
  selectedMenu !: string;
  AppRoutes = AppRoutes;
  /**
   * Selects a menu item.
   * 
   * @param menu The menu item to select
   */
  selectMenu(menu: string) {
    this.selectedMenu = menu;
  }

  constructor(
    private responsivesidebarService: ResponsivesidebarService,
    private renderer: Renderer2,
    private menuService: MenuService
  ) { }
  private sub?: Subscription;
  /**
   * Subscribes to sidebar open state and updates body class accordingly.
   */
  ngOnInit() {
    // Subscribe to menu changes
    this.menuService.selectedMenu$.subscribe(menu => {
      if (menu) {
        this.selectedMenu = menu;
      }

    });
    this.sub = this.responsivesidebarService.isOpen$.subscribe((isOpen) => {
      if (isOpen) {
        this.renderer.addClass(document.body, "menu-open");
      } else {
        this.renderer.removeClass(document.body, "menu-open");
      }
    });
  }
  /**
   * Unsubscribes from sidebar state changes to prevent memory leaks.
   */
  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    this.sub?.unsubscribe();
  }

  /**
   * Toggles the sidebar open/close state.
   */
  toggleSidebarClose() {
    // Optional: if sidebar has its own toggle button
    this.responsivesidebarService.toggle();
  }
}
